import React from "react";
import { StatCard } from "../../../components/StatCard";
import PendingApprovalsCard from "../../../components/Files/PendingApprovalsCard";
import AppointmentsTableCard from "../../../components/Files/AppointmentsTableCard";

// Props type
interface UserStatisticsTabProps {
  data: any[];
  approvals: any;
  parents: any[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
  statCards: (data: any[]) => { title: string; value?: number; icon: React.ReactElement; gradient: string; navigatePath?: string }[];
}

const UserStatisticsTab: React.FC<UserStatisticsTabProps> = ({
  data,
  approvals,
  parents,
  activeTab,
  setActiveTab,
  statCards,
}) => {

  return (
    <>
      <h3 className="text-2xl font-semibold text-gray-800 mb-4 border-b-4 border-blue-500 pb-2">
        User Statistics
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-10">
        {statCards(data).map((card, index) => (
          <StatCard
            key={index}
            title={card.title}
            value={card.value || 0}
            icon={card.icon}
            bgGradient={card.gradient}
            navigatePath={card.navigatePath}
          />
        ))}
      </div>

      <PendingApprovalsCard 
        approvals={approvals}
        setActiveTab={setActiveTab}
        activeTab={activeTab}
      />

      <div className="gap-6 mt-5">
        <AppointmentsTableCard
          title="Pet Owners"
          data={parents}
          navigatePath="/users?role=parent"
          columns={[
            {
              key: "name",
              label: "Name",
              render: (item) => {
                const user = item?.user;
                return (
                  <span className="text-blue-600 truncate max-w-[100px]">
                    {user?.first_name} {user?.last_name}
                  </span>
                );
              },
            },
            // {
            //   key: "city",
            //   label: "City",
            //   render: (item) => item?.user?.address?.city || "-",
            // },
          
            {
              key: "mobile",
              label: "Mobile",
              render: (item) => item?.user?.mobile || "-",
            },
            {
              key: "email",
              label: "Email",
              render: (item) => item?.user?.email || "-",
            },
            {
              key: "status",
              label: "Status",
              render: (item) => {
                const user = item?.user;
                const isActive = Number(user?.is_active);
                const status =
                  isActive === 1
                    ? "Active"
                    : isActive === 2
                    ? "Deactivated"
                    : "Inactive";
                return status;
              },
              isStatus: true,
            },
          ]}
          statusColorMap={{
            Active: "bg-green-200 text-green-900",
            Deactivated: "bg-red-200 text-red-900",
            Inactive: "bg-gray-200 text-gray-900",
          }}
        />
      </div>
    </>
  );
};

export default UserStatisticsTab;
